import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const Input = styled.input`
  border: 1px solid ${color("border")};
`;
